define('services/qm/interactionsListFilterService',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'services/loggingService',
    'services/userService',
    'services/userSettingsService'
], function (_, ko, Promise, loggingService, userService, userSettingsService) {
    "use strict";

    var VIEWMODELSETTINGSKEY = 'interactionsSearch';
    var PAGE_SIZE_KEY = 'pageSize';

    var searchFilterSettings = null;
    ko.computed(function () {
        ko.unwrap(userService.currentUser);
        searchFilterSettings = null;
    });

    // This service gets and sets each of the interactionsList viewModels' last used
    // searchFilters lists from userSettingsService.
    // This also allows other views to set filters for the interactionsList
    // prior to navigating to it.
    var interactionsListFilterService = {
        SEARCH_RESULTS_KEY: 'lastSearchFilter',
        ARCHIVED_SEARCH_RESULTS_KEY: 'lastArchivedSearchFilter',

        getFilters: function(filterKey) {
            if (userService.currentUser()) {
                if (searchFilterSettings) {
                    return Promise.resolve(searchFilterSettings[filterKey]);
                } else {
                    return userSettingsService.getSettings(VIEWMODELSETTINGSKEY)
                    .then(function (settings) {
                        if (settings &&
                            settings[VIEWMODELSETTINGSKEY] &&
                            settings[VIEWMODELSETTINGSKEY][filterKey]) {
                            return settings[VIEWMODELSETTINGSKEY][filterKey];
                        }
                        return [];
                    })
                    .catch(function (error) {
                        // This is a fairly benign error, don't notify the user.
                        loggingService.error("Failed to retrieve the user's last search filter setting", error);
                        return [];
                    });
                }
            } else {
                return Promise.resolve(null);
            }
        },
        setFilters: function(filterKey, searchFilters) {
            if (!searchFilterSettings) {
                searchFilterSettings = {};
            }
            searchFilterSettings[filterKey] = searchFilters;

            var newSettings = {};
            newSettings[VIEWMODELSETTINGSKEY] = ko.toJS(searchFilterSettings);
            return userSettingsService.setSettings(newSettings)
            .catch(function (error) {
                // This is a fairly benign error, don't notify the user.
                loggingService.error("Failed to update the user's last search filter setting", error);
            });
        },

        getPageSize: function() {
            if (userService.currentUser()) {
                if (searchFilterSettings) {
                    return Promise.resolve(searchFilterSettings[PAGE_SIZE_KEY]);
                } else {
                    return userSettingsService.getSettings(VIEWMODELSETTINGSKEY)
                    .then(function (settings) {
                        if (settings && settings[VIEWMODELSETTINGSKEY]) {
                            searchFilterSettings = settings[VIEWMODELSETTINGSKEY];
                        } else {
                            searchFilterSettings = {};
                        }
                        return searchFilterSettings[PAGE_SIZE_KEY];
                    })
                    .catch(function (error) {
                        // This is a fairly benign error, don't notify the user.
                        loggingService.error("Failed to retrieve the user's page size setting", error);
                    });
                }
            } else {
                return Promise.resolve(null);
            }
        },
        setPageSize: function(pageSize) {
            if (!searchFilterSettings) {
                searchFilterSettings = {};
            }
            searchFilterSettings[PAGE_SIZE_KEY] = pageSize;

            var newSettings = {};
            newSettings[VIEWMODELSETTINGSKEY] = ko.toJS(searchFilterSettings);
            return userSettingsService.setSettings(newSettings)
            .catch(function (error) {
                // This is a fairly benign error, don't notify the user.
                loggingService.error("Failed to update the user's page size setting", error);
            });
        }
    };

    return interactionsListFilterService;
});

